import { testId } from '../../utils';
import { Iconography } from './Iconography';
import { Typography } from './Typography';
import * as Tooltips from '@radix-ui/react-tooltip';
import clsx from 'clsx';
import React, { useCallback } from 'react';

export interface TooltipProps {
  content: React.ReactNode;
  directon?: 'top' | 'right' | 'bottom' | 'left';
  'data-testid': string;
}

export const Tooltip: React.FC<TooltipProps> = ({
  content,
  directon = 'right',
  'data-testid': dataTestId,
}) => {
  const [open, setOpen] = React.useState(false);

  const handleClick = useCallback(
    (event: { preventDefault: () => void }) => {
      event.preventDefault();
      setOpen(true);
    },
    [setOpen],
  );

  return (
    <Tooltips.Provider>
      <Tooltips.Root open={open} onOpenChange={setOpen}>
        <Tooltips.Trigger asChild>
          <button {...testId(dataTestId, 'trigger')} onClick={handleClick}>
            <Iconography
              variant="info"
              className="text-gray-darkest text-base pt-1"
            />
          </button>
        </Tooltips.Trigger>
        <Tooltips.Portal>
          <Tooltips.Content
            {...testId(dataTestId)}
            align="start"
            className={clsx(
              'max-w-[140px] md:max-w-[230px] p-2 md:p-4 ',
              'shadow-tooltip rounded bg-white text-gray-darkest text-wrap',
              'align-middle justify-center flex',
            )}
            side={directon}
            sideOffset={5}
          >
            <Typography variant="footnote"> {content} </Typography>
          </Tooltips.Content>
        </Tooltips.Portal>
      </Tooltips.Root>
    </Tooltips.Provider>
  );
};
